import { gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { OnlinePayment, OnlinePaymentFindRequest } from '../type'

export const GetOnlinePayments: TypedDocumentNode<
  QueryPageableResponse<OnlinePayment, 'onlinePaymentsFind'>,
  QueryPageableRequest<OnlinePaymentFindRequest>
> = gql`
  query GetOnlinePayments($request: OnlinePaymentRequest!) {
    onlinePaymentsFind(request: $request) {
      data 
      count
    }
  }
`

